export const TIME_ZONE = 'America/Guatemala'
export const FORMAT_DATE_LARGE = "dd 'de' MMMM 'del' yyyy"
export const FORMAT_DATE_LARGE_TIME = "dd 'de' MMMM 'del' yyyy 'a las' HH:mm:ss a"
export const LOCALE_CURRENCY = 'es-GT'
export const LOCAL_CURRENCY = 'GTQ'
const CODE_LENGTH = 10

const CODE_PREFIX = {
  client: 'C',
  negotiation: 'N',
  delivery: 'E',
  property: 'I'
} as const

type CodeModule = keyof typeof CODE_PREFIX

/**
 * Formatea un código numérico con padding de ceros.
 * Sin prefijo: `formatCode(123)` → `"0000000123"`
 * Con prefijo: `formatCode(123, 'negotiation')` → `"N-0000000123"`
 */
export function formatCode(code: number | string | null | undefined, module?: CodeModule): string {
  if (code == null) return 'N/A'
  const padded = code.toString().padStart(CODE_LENGTH, '0')
  if (!module) return padded
  return `${CODE_PREFIX[module]}-${padded}`
}
export const BASE64_REGEX = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/

export const COUNTRY_LOCAL = {
  db_id: '65b8a9a9ffc1587a94ffb582',
  id: '1decb934-efd4-4c0d-9e95-693d64396759',
  isoCode: 'GT',
  nationality: {
    default: 'GUATEMALA',
    female: 'GUATEMALTECA',
    male: 'GUATEMALTECO'
  },
  default: true,
  iso: {
    alpha2: 'GT'
  },
  name: {
    es: 'GUATEMALA',
    en: 'GUATEMALA'
  },
  code: {
    catalogReportAccount: 1
  }
}
export const DEPARTMENT_DEFAULT_GT = {
  db_id: '65b8ad48006a8955e167a321',
  id: 'ed7c5084-934a-4a18-b8c5-e3c00a4cbee8',
  name: 'GUATEMALA',
  code: 1,
  country: 'GT',
  default: true
}

export const MUNICIPALITY_DEFAULT_GT = {
  db_id: '65b8b28e44edafe06ab00c68',
  id: 'f388f424-d63d-4ac8-a7e3-c325b56fd85f',
  idOld: 108,
  name: 'Guatemala',
  code: 101,
  department: 1,
  default: true
}
